import { rgba } from 'polished';
import { index, Options } from 'shared/assets/styles';
import { sideNavigationHoverClass } from 'shared/constants';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const SmallScreenBackdrop = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: -100%;
  right: 100%;
  z-index: ${index(Options.SIDE_NAVIGATION_BACKDROP)};

  opacity: ${({ $open }) => ($open ? 1 : 0)};
  background: ${({ theme }) => rgba(theme.palette.common.black, 0.3)};
  transition: opacity 200ms;

  ${({ $open }) =>
    $open &&
    css`
      left: 0;
      right: 0;
    `};

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: none;
  }

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const ContentContainer = styled.div<{
  $smallScreenOpen: boolean;
  $open: boolean;
}>`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;

  overflow: hidden;
  background: ${({ theme }) => theme.palette.background.paper};

  padding: ${({ theme, $smallScreenOpen, $open }) =>
    `0 ${theme.spacing($smallScreenOpen ? 2 : 0)} 0 ${theme.spacing($open ? 2 : 0)}`};

  @media (any-hover: hover) {
    .${sideNavigationHoverClass} {
      opacity: 0;
      transition: opacity 200ms;
    }

    &:hover {
      .${sideNavigationHoverClass} {
        opacity: 1;
      }
    }
  }
`;

export const AppNavBar = styled.div`
  -webkit-app-region: drag;
  display: flex;
  justify-content: flex-end;

  padding: ${({ theme }) =>
    `${theme.spacing(4.5)} ${theme.spacing(0.75)}
    ${theme.spacing(0.5)} ${theme.spacing(3.5)}`};

  color: ${({ theme }) => theme.palette.grey[500]};
`;

export const Header = styled.div<{ $isMac: boolean }>`
  padding: ${({ theme, $isMac }) =>
    `${theme.spacing($isMac ? 0.5 : 3.5)} ${theme.spacing(0.75)}
    ${theme.spacing(2)} ${theme.spacing(1.5)}`};
`;

export const List = styled.ul`
  flex: 1;
  overflow: auto;
  margin: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(1)} ${theme.spacing(6)}`};

  list-style: none;
`;

export const ListItem = styled.li``;

export const SubNavigationList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const SubNavigationListItem = styled.li``;

export const ComingSoon = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: block;

  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(2)}`};

  background: ${({ theme }) => theme.palette.grey['100']};
  border-radius: ${({ theme }) => theme.spacing(6)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const FeedbackButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
`;

export const SmartListContainer = styled.div`
  padding-left: ${({ theme }) => theme.spacing(2)};
`;
